<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import Pagination from "@/router/layouts/table-pagination.vue";
import Datatable from "@/router/layouts/table-datatable.vue";
import _ from "lodash";

import ModalFormSettingUserHCBP from "./components/modal-form-setting-user-hcbp.vue";
import ModalImportSettingUserHCBP from "./components/modal-import-setting-user-hcbp.vue";
import ModalImportMessageSettingUserHCBP from "./components/modal-import-message-setting-user-hcbp.vue";

export default {
  page: {
    title: "Setting User HCBP",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Pagination,
    Datatable,
    ModalFormSettingUserHCBP,
    ModalImportSettingUserHCBP,
    ModalImportMessageSettingUserHCBP,
  },

  data() {
    let sortOrders = [];

    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Nama", name: "name" },
      { width: "auto", label: "Area", name: "-" },
      { width: "180px", label: "Aksi", name: "-" }, // jika tidak ada sorting kasih name dengan karakter -
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    const menu = "Master - Setting User HCBP";
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      title: menu,
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      user_name: localStorage.session_name,
      pathPhoto: localStorage.session_path_photo,
      pathPhotoFull:
        process.env.VUE_APP_BACKEND_URL + localStorage.session_path_photo,
      modalShow: false,
      loadingTable: false,
      tableData: [],
      columns: columns,
      sortKey: "name",
      sortOrders: sortOrders,
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "name",
        dir: "asc",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },

      importFailedResult: {
        success: [],
        failed: [],
      },

      modalConfiguration: {
        SettingUserHCBP: false,
        ImportSettingUserHCBP: false,
        ImportFailedSettingUserHCBP: false,
      },

      // variable form SettingUserHCBP
      selectedDataFormSettingUserHCBP: null,
      formModeSettingUserHCBP: "add",
    };
  },

  mounted() {
    // if (this.isWrite != 1) this.columns.pop();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
    this.getDataTable();
  },

  methods: {
    async getDataTable(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;

      const data = await axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/setting-user-hcbp",
        params: this.tableFilter,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });

      if (data) {
        this.tableData = data.data.data;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.data.last_page_url;
        this.pagination.nextPageUrl = data.data.next_page_url;
        this.pagination.prevPageUrl = data.data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },

    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable(false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },

    importSettingUserHCBP() {
      this.modalConfiguration.ImportSettingUserHCBP = true;
    },

    showImportFailed(result) {
      this.modalConfiguration.ImportSettingUserHCBP = false;
      this.importFailedResult = result;
      this.modalConfiguration.ImportFailedSettingUserHCBP = true;
    },

    closeImportFailed() {
      this.modalConfiguration.ImportFailedSettingUserHCBP = false;
      this.modalConfiguration.ImportSettingUserHCBP = true;
    },

    addSettingUserHCBP() {
      this.formModeSettingUserHCBP = "add";
      this.selectedDataFormSettingUserHCBP = null;
      this.modalConfiguration.SettingUserHCBP = true;
    },

    editSettingUserHCBP(data) {
      this.formModeSettingUserHCBP = "edit";
      this.selectedDataFormSettingUserHCBP = data;
      this.modalConfiguration.SettingUserHCBP = true;
    },

    destroy(userId) {
      Swal.fire({
        icon: "warning",
        title: "Apakah anda yakin melepas area pegawai ini ?",
        text: "Assignment area pada pegawai ini akan dihapus.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Ya",
        denyButtonText: "Tidak",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "delete",
            url:
              this.BACKEND_URL_VERSION +
              "master/setting-user-hcbp/" +
              userId,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err delete data:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });

          if (data) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Data berhasil dihapus",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false
            });
            this.getDataTable();
          }
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <!-- Content -->
        <div class="card">
          <div class="card-body">
            <!-- Filter -->
            <div class="row">
              <div class="col-12 text-end">
                <b-button
                  v-if="isWrite || isWrite == 1"
                  variant="success"
                  size="sm"
                  class="me-2"
                  @click="importSettingUserHCBP"
                >
                  <i class="fa fa-file-excel"></i>
                  Import Excel
                </b-button>

                <b-button variant="primary" size="sm" @click="addSettingUserHCBP">
                  <i class="fa fa-plus"></i>
                  Tambah
                </b-button>
              </div>
            </div>

            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getDataTable()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i>
                      Loading
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length < 1">
                    <td colspan="99" class="text-center">Data Empty</td>
                  </tr>
                  <tr v-else v-for="(row, index) in tableData" :key="index">
                    <td class="text-center">{{ index + pagination.from }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.area?.kode_area ?? "-" }}</td>
                    <td class="text-center">
                      <div class="btn-group">
                        <b-button
                          variant="warning"
                          size="sm"
                          @click="editSettingUserHCBP(row)"
                        >
                          <i class="fa fa-edit me-1"></i>
                          Edit
                        </b-button>

                        <button
                          class="btn btn-danger btn-sm"
                          @click="destroy(row.user_id)"
                        >
                          <i class="fa fa-trash me-1"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
              <Pagination
                :pagination="pagination"
                @to-page="toPage"
              ></Pagination>
            </div>

            <div class="row">
              <div class="col-12">
                <ModalFormSettingUserHCBP
                  :show="modalConfiguration.SettingUserHCBP"
                  :data="selectedDataFormSettingUserHCBP"
                  :mode="formModeSettingUserHCBP"
                  @close="modalConfiguration.SettingUserHCBP = false"
                  @finish="getDataTable()"
                />

                <ModalImportSettingUserHCBP
                  :show="modalConfiguration.ImportSettingUserHCBP"
                  @close="modalConfiguration.ImportSettingUserHCBP = false"
                  @finish="getDataTable()"
                  @show-failed="showImportFailed"
                />

                <ModalImportMessageSettingUserHCBP
                  :show="modalConfiguration.ImportFailedSettingUserHCBP"
                  :result="importFailedResult"
                  @close="closeImportFailed"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>